const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029VbDiYx61XquVH87GhW2Z";

export default function WhatsAppSection(props) {
  const displayName = props.data?.name || "Al Zahrah Islamic Center";

  return (
    <div id="WhatsAppSection" style={{ width: "100%" }}>
      <style>{`
        .whatsapp-container {
          background: linear-gradient(135deg, #25D366 0%, #1a8f5a 100%);
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(37, 211, 102, 0.2);
        }
        .whatsapp-header {
          background: #25D366;
          padding: 28px 32px;
          display: flex;
          align-items: center;
          gap: 16px;
          color: #fff;
        }
        .whatsapp-header-text h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          color: #fff;
        }
        .whatsapp-header-text p {
          margin: 4px 0 0;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.9);
        }
        .whatsapp-content {
          padding: 32px;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 24px;
        }
        .whatsapp-description {
          font-size: 15px;
          color: #555;
          line-height: 1.6;
          margin: 0;
        }
        .whatsapp-channel-button {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 22px;
          background-color: #25d366;
          color: #ffffff;
          font-family: Arial, sans-serif;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
          border-radius: 8px;
          transition: transform 0.2s ease, background-color 0.2s ease;
          border: none;
          cursor: pointer;
        }
        .whatsapp-channel-button:hover {
          background-color: #1ebe5d;
          transform: translateY(-2px);
        }
        .whatsapp-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }
        @media (max-width: 600px) {
          .whatsapp-header {
            padding: 20px 16px;
          }
          .whatsapp-content {
            padding: 20px 16px;
          }
          .whatsapp-header-text h3 {
            font-size: 16px;
          }
        }
      `}</style>

      <div className="whatsapp-container">
        {/* Header */}
        <div className="whatsapp-header">
          <div className="whatsapp-header-text">
            <h3>WhatsApp Channel</h3>
            <p>Get instant updates & announcements</p>
          </div>
        </div>

        {/* Content */}
        <div className="whatsapp-content">
          <p className="whatsapp-description">
            Join our WhatsApp Channel to receive real-time notifications about prayers, events, lectures, and community announcements. Stay connected with {displayName} wherever you are!
          </p>

          {/* Join Button */}
          <a 
            href={WHATSAPP_CHANNEL_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatsapp-channel-button"
          >
            <svg
              className="whatsapp-icon"
              viewBox="0 0 32 32"
              aria-hidden="true"
            >
              <path
                fill="currentColor"
                d="M16.04 3C9.39 3 4 8.32 4 14.88c0 2.3.67 4.55 1.94 6.47L4 29l7.88-2.04a12.1 12.1 0 0 0 4.15.73h.01C22.69 27.69 28 22.37 28 15.82 28 9.27 22.69 3 16.04 3Zm0 22.67a10.2 10.2 0 0 1-3.89-.77l-.56-.22-4.68 1.21 1.25-4.54-.25-.58a9.85 9.85 0 0 1-1.03-4.4c0-5.47 4.12-9.92 9.18-9.92 5.07 0 9.18 4.45 9.18 9.92 0 5.47-4.11 9.3-9.2 9.3Zm5.03-7.43c-.28-.14-1.65-.81-1.9-.9-.26-.1-.45-.14-.64.14-.19.28-.73.9-.9 1.08-.16.19-.33.21-.61.07-.28-.14-1.18-.43-2.25-1.38-.83-.73-1.39-1.63-1.55-1.91-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.64-1.54-.88-2.11-.23-.56-.47-.48-.64-.49h-.54c-.19 0-.49.07-.75.35-.26.28-.99.97-.99 2.36 0 1.4 1.02 2.74 1.16 2.93.14.19 2 3.05 4.84 4.28.68.29 1.21.47 1.62.6.68.22 1.3.19 1.79.12.55-.08 1.65-.68 1.88-1.33.23-.66.23-1.22.16-1.33-.07-.12-.25-.19-.53-.33Z"
              />
            </svg>
            Join Our WhatsApp Channel
          </a>

          {/* Arabic Description */}
          <p style={{
            fontSize: 14,
            color: "#666",
            lineHeight: 1.8,
            margin: "20px 0 0",
            direction: "rtl",
            textAlign: "right",
            fontFamily: "'Georgia','Times New Roman',serif",
            maxWidth: 420,
          }}>
            انضموا إلى قناتنا على واتساب لتصلكم أحدث الإشعارات حول مواعيد الصلاة، والفعاليات، والمحاضرات، وإعلانات المجتمع. ابقوا على تواصل دائم مع مركز الزهراء الإسلامي أينما كنتم!
          </p>
        </div>
      </div>
    </div>
  );
}
